(function certificateFindControllerDefinition() {
    'use strict';

    angular.module('Certificate')
        .controller('CertificateFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processCustomerService', 'configViewService', 'authExtend', '$translate', 'storageService', 'fileDownloader', 'certificateService', 'profileCertificateService',
            function certificateFindController($q, $filter, $scope, $state, errors, processCustomerService, configViewService, auth, $translate, storageService, fileDownloader, certificateService, profileCertificateService) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                $scope.showAddCertificate = auth.isInRole('CERTIFICATECUSTOMER WRITE');

                $scope.createFilters = function () {
                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: $scope.find.organizationalUnitId,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    //filtro instalados y revocados
                    filters.processStatesIds = filters.processStatesIds.filter(function (e) { return e !== '213' && e !== '214' && e !== '219' });
                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return processCustomerService.advancedGet(filters).then(function (result) {

                        $scope.certificates = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    r.metadatas.push({ value: metadataFound[0].value, type: metadataFound[0].type });
                                } else {
                                    r.metadatas.push({ value: null, type: null });
                                }
                            });

                            $scope.certificates.push(r);
                        });

                        if ($scope.certificates.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.certificates.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.addCertificate = function () {
                    $state.go('profile-add-certificate');
                };

                $scope.findAction = function () {
                    if (!$scope.certificateFind.$valid) {
                        $scope.certificateFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setCertificatesFilter($scope.find);

                    return $scope.executeFind();
                };

                $scope.exportToExcel = function () {
                    return $translate(['ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                        .then(function (translated) {
                            var headers = [];
                            var filters = $scope.createFilters();
                            filters.itemPerPage = null;
                            filters.page = null;
                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });

                            return processCustomerService.exportToXLS(filters, headers, 'Certificados').then(function (result) {
                                var d = new Date();

                                var docName = "Certificados";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                errors.showError('Api failed');
                            });
                        });
                };

                $scope.downloadCertificate = function (item) {
                    return profileCertificateService.downloadCertificate(item).then(function (result) {
                        var d = new Date();

                        var docName = "Certificado";

                        var success = fileDownloader.saveAs(result.value, docName +
                            '_' +
                            d.getUTCFullYear() +
                            '-' +
                            (d.getUTCMonth() + 1) +
                            '-' +
                            d.getDate() +
                            '.pfx');
                        
                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        errors.showError(error.data.modelState.nocert[0]);
                    });
                };

                $scope.view = function (cert) {
                    $state.go('certificate-detail', { id: cert.id });
                };

                $scope.edit = function (cert) {
                    $state.go('certificate-edit', { id: cert.id });
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearCertificatesFilter();

                    $scope.find = storageService.getCertificatesFilter();
                    $scope.certificates = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.certificates.forEach(function (certificate) {
                        var accordionIsOpen = false;
                        Object.defineProperty(certificate, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }

                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    })

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        configViewService.getById("CPPCertificate").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.loadCertificates = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    profileCertificateService.getAll().then(function (result) {
                        $scope.allCertificates = result;
                        $scope.showCertificates = true;
                        defered.resolve();
                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                    });

                    return promise;
                };

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.userId = auth.getUserId();
                    $scope.find = storageService.getCertificatesFilter();
                    $scope.showDownloadCertificate = false;
                    $scope.showCertificates = false;
                    $scope.find.showResult = false;

                    $q.all([$scope.loadViewOptions(), $scope.loadCertificates()]).then(function (result) {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    });
                };

                $scope.load();
            }]);
})();